<template>
  <el-dialog title="消息通知" :visible.sync="show">
    <div>
      <el-button
        type="danger"
        style="float:right ;"
        :disabled="disabledDel"
        @click="deleteAdd"
      >批量删除</el-button>
      <el-button
        type="primary"
        style="float:right ; margin-right:10px"
        :disabled="disabled"
        @click="readmassage"
      >一键已读</el-button>
    </div>

    <el-table
      :data="tableData"
      stripe="true"
      style="width: 100%"
      @row-click="hangckip"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />

      <el-table-column prop="TITLE" label="消息标题" width="180" />
      <el-table-column prop="REMIND_TYPE" label="消息类型" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.REMIND_TYPE == 'GD'">
            {{ scope.row.REMIND_TYPE == "GD" ? "工单" : "" }}</span>
          <span v-if="scope.row.REMIND_TYPE == 'WB'">
            {{ scope.row.REMIND_TYPE == "WB" ? "维保" : "" }}</span>
          <span v-if="scope.row.REMIND_TYPE == 'WATER'">
            {{ scope.row.REMIND_TYPE == "WATER" ? "水物联" : "" }}</span>
          <span v-if="scope.row.REMIND_TYPE == 'FIRE'">
            {{ scope.row.REMIND_TYPE == "FIRE" ? "火警" : "" }}</span>

          <span v-if="scope.row.REMIND_TYPE == 'WP'">
            {{ scope.row.REMIND_TYPE == "WP" ? "水泵" : "" }}</span>
          <span v-if="scope.row.REMIND_TYPE == 'NB'">
            烟感
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="CONTENT" label="内容" width="180" />
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag :size="scope.row.IS_READ == '1' ? 'info' : 'medium'">
            {{ scope.row.IS_READ == "1" ? "已读" : "未读" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="REMIND_TIME" label="提醒时间" />
      <!-- <el-table-column
        prop="RECEIVE_USER"
        label="接收人">
      </el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- <el-button
          size="mini"
          @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
          <el-button
            size="mini"
            type="danger"
            @click.stop="handleDelete(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="blocks">
      <el-pagination
        hide-on-single-page="false"
        background
        :current-page="pageNum"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </el-dialog>
</template>

<script>
// import {mapMutation} from 'vuex'

// import qs from 'qs'
export default {
  data() {
    return {
      show: false,
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      massageSelection: [] // 全选的
      //    disabledDel:false,
      //    disabled:true,
    }
  },
  /* eslint-disable */
  computed: {
    disabled: function() {
      const a = this.tableData.find(item => {
        if (item.IS_READ == "0") {
          return true;
        }
      });
      if (a) {
        return false;
      } else {
        return true;
      }
    },
    disabledDel: function() {
      if (this.massageSelection.length == 0) return true;
    }
  },
  created() {
    this.getqueryRemind();
    // vue的生命周期 创建前
    this.$EventBus.$on("massageShow", msg => {
      this.show = msg;
    });
  },
  methods: {
    deleteAdd() {
      let deleteData = [];
      this.massageSelection.filter(item => {
        deleteData.push(item.ID);
      });

      deleteData = deleteData.join(",");

      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteMassage(deleteData);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async readmassage() {
      const request = await this.$axios.put(
        "/api/remind/allIsRead",
        {},
        { headers: { Authorization: this.$store.getters.token } }
      );
      if (request.data.code == 200) {
        this.$message({
          message: "全部已读",
          type: "success"
        });
      }
    },
    resetForm(formName) {
      this.show = false;
      this.$refs[formName].resetFields();
    },
    // 点击上传用户信息
    // /remind/queryRemind
    async getqueryRemind() {
      const token = this.$store.getters.token;
      const request = await this.$axios.get(
        "/api/remind/queryRemind?pageNum=" +
          this.pageNum +
          "&pageSize=" +
          this.pageSize,
        {
          headers: { Authorization: token }
        }
      );
      if (request.data.data.length !== 0) {
        const total = request.data.data.pop();
        this.total = parseInt(total.total);
      }
      this.tableData = request.data.data;
    },
    handleSizeChange(index) {
      this.pageSize = index;
      this.getqueryRemind();
    },
    handleCurrentChange(index) {
      this.pageNum = index;
      this.getqueryRemind();
    },
    hangckip(row, column, event) {
      this.putUpdate(row);
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteMassage(row.ID);
          // /remind/delete
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    async deleteMassage(remindId) {
      const token = this.$store.getters.token;
      const request = await this.$axios
        //  remindId=222,333 如果多个用英文,分割多个id
        .delete("/api/remind/delete?remindId=" + remindId, {
          headers: { Authorization: token }
        });
      if (request.data.code == 200) {
        this.getqueryRemind();
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      }
    },
    // /remind/update
    async putUpdate(remindId) {
      if (remindId.ID) {
        const token = this.$store.getters.token;
        const request = await this.$axios.put(
          "/api/remind/update?remindId=" + remindId.ID,
          {},
          {
            headers: { Authorization: token }
          }
        );
        if (request.data.code == 200) {
          if (remindId.REMIND_TYPE == "WB") {
            this.$router.push({ name: "MaintorderReport" });
          }
          if (remindId.REMIND_TYPE == "GD") {
            this.$router.push({ name: "workOrder" });
          }
          if (remindId.REMIND_TYPE == "WATER") {
            this.$router.push({ name: "Water" });
          }
          if (remindId.REMIND_TYPE == "FIRE") {
            this.$router.push({ name: "FireAlarm" });
          }
          if (remindId.REMIND_TYPE == "WP") {
            this.$router.push({ name: "waterPump" });
          }

          
          //  this. this.getqueryRemind()
          this.show = false;
        }
        // this.$message(request.data.code)
      } else {
        this.$message.error("失败，请刷新重试！");
      }
    },

    handleSelectionChange(selection) {
      this.massageSelection = selection;
    }

    // 获取数据
  }
};
/* eslint-enable */
</script>

<style lang="scss" scoped>
// 图片上传

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploaders {
  width: 178px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  margin-right: 20px;
}
.avatar-uploaders:hover {
  border-color: #409eff;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
  // background-color: aqua;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.block {
  //   margin-top: 15px;
  //   float: right;
}

// 图片上传
</style>
